import React from "react";
import { Sparkle } from "lucide-react";

export default function MarqueeTapes() {
  const orangeItems = ["Content Strategy", "Pipeline Building", "Voice Extraction"];
  const blackItems = ["B2B Founders", "10M+ Impressions", "96% Consistency"];

  const renderItems = (items, count = 12) => {
    const arr = [];
    for (let i = 0; i < count; i++) arr.push(...items);
    return arr;
  };

  return (
    <section
      className="relative w-full overflow-hidden"
      style={{ height: 340, marginTop: 60 }}
    >
      <div className="tape tape-orange" style={{ top: "45%" }}>
        <div className="tape-content">
          {renderItems(orangeItems).map((label, i) => (
            <div
              key={`o-${i}`}
              className="flex items-center gap-6 px-8 text-[24px] font-semibold whitespace-nowrap"
            >
              <span>{label}</span>
              <Sparkle size={20} className="opacity-90" />
            </div>
          ))}
        </div>
      </div>

      <div className="tape tape-black" style={{ top: "45%" }}>
        <div className="tape-content" style={{ animationDirection: "reverse" }}>
          {renderItems(blackItems).map((label, i) => (
            <div
              key={`b-${i}`}
              className="flex items-center gap-6 px-8 text-[24px] font-semibold whitespace-nowrap"
            >
              <span>{label}</span>
              <Sparkle size={20} className="opacity-90" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
